import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import Layout from 'components/common/Layout';
import SignUpPhoneConfirm from 'components/account/SignUpPhoneConfirm';
import AccountNavigation from 'components/account/AccountNavigation';
import AccountLogo from 'components/account/AccountLogo';

import { accountSignUpSendCode } from 'redux/modules/account';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import tidioSrc from 'config/tidioSrc';

class AccountSignUpPhoneConfirm extends Component {
  componentDidMount() {
    const { history } = this.props;
    const htmlEl = document.querySelector('html');
    htmlEl.classList.add('page-with-tidio');
    if (!history.location.state || !history.location.state.email) {
      history.replace('/account/login');
    }
  }

  componentWillUnmount() {
    const htmlEl = document.querySelector('html');
    htmlEl.classList.remove('page-with-tidio');
  }

  render() {
    const { recoverOrder, record, history } = this.props;
    return (
      <Layout variant="account-login">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Log In
          </title>
          <script src={tidioSrc} async />
        </Helmet>
        <AccountLogo />
        <SignUpPhoneConfirm
          initialValues={{
            'Phone Number': history.location.state.phone,
            Email: history.location.state.email,
          }}
          onPhoneChange={(values) => {
            history.replace({
              pathname: history.location.pathname,
              state: {
                phone: values['Phone Number'],
                email: history.location.state.email,
              },
            });
          }}
          onSubmitSuccess={(values) => {
            history.push({
              pathname: '/account/sign-up-company',
              state: {
                email: history.location.state.email,
              },
            });
          }}
        />
        <AccountNavigation />
      </Layout>
    );
  }
}

AccountSignUpPhoneConfirm.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export default AccountSignUpPhoneConfirm;



// WEBPACK FOOTER //
// ./src/pages/account/AccountSignUpPhoneConfirm.js